import script from "./EditClientInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EditClientInfo.vue?vue&type=script&setup=true&lang=js"

import "./EditClientInfo.vue?vue&type=style&index=0&id=010c954e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010c954e"]])

export default __exports__